import axios, { AxiosResponse } from 'axios';
import config from "app/api/axiosConfig";
import { Album } from 'app/api/types';
import get from 'lodash-es/get';

export default (token: string, album: Album ) =>
	axios.put(`${process.env.REACT_APP_GALLERY_HOST}/gallery/albums`, album, config(token)).then((response: AxiosResponse) => {
		const album: Album = get(response, "data", {});
		return Promise.resolve(album);
	})
